export function toPxString(value: number) {
  return `${value}px`;
}
